import '@tylertech/forge/skeleton';
import './Skeleton.css';

const SkeletonElement = 'forge-skeleton' as React.ElementType;

export interface TableSkeletonProps {
  rows?: number;
  columns?: number;
}

export function TableSkeleton({ rows = 10, columns = 5 }: TableSkeletonProps): JSX.Element {
  return (
    <div className="skeleton-table" role="status" aria-label="Loading table data">
      <div className="skeleton-table__header">
        {Array.from({ length: columns }).map((_, i) => (
          <SkeletonElement
            key={i}
            text
            className={
              i === 0 ? 'skeleton-table__header-cell--first' : 'skeleton-table__header-cell'
            }
          />
        ))}
      </div>
      <div className="skeleton-table__body">
        {Array.from({ length: rows }).map((_, rowIdx) => (
          <div key={rowIdx} className="skeleton-table__row">
            {Array.from({ length: columns }).map((_, colIdx) => (
              <SkeletonElement
                key={colIdx}
                text
                style={{
                  width:
                    colIdx === 0
                      ? `${60 + ((rowIdx * 7 + colIdx * 13) % 30)}%`
                      : `${50 + ((rowIdx * 11 + colIdx * 7) % 40)}%`,
                }}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export interface DetailSkeletonProps {
  cards?: number;
}

export function DetailSkeleton({ cards = 4 }: DetailSkeletonProps): JSX.Element {
  return (
    <div className="skeleton-detail" role="status" aria-label="Loading details">
      <div className="skeleton-detail__header">
        <SkeletonElement text className="skeleton-detail__header-title" />
        <div className="skeleton-detail__header-actions">
          <SkeletonElement button />
          <SkeletonElement button />
        </div>
      </div>
      <div className="skeleton-detail__cards">
        {Array.from({ length: cards }).map((_, i) => (
          <div key={i} className="skeleton-detail__card">
            <SkeletonElement text className="skeleton-detail__card-title" />
            {Array.from({ length: 4 }).map((_, j) => (
              <div key={j} className="skeleton-detail__field">
                <SkeletonElement text className="skeleton-detail__field-label" />
                <SkeletonElement text style={{ width: `${45 + ((i * 9 + j * 11) % 35)}%` }} />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export function WidgetSkeleton(): JSX.Element {
  return (
    <div className="skeleton-widget" role="status" aria-label="Loading widget">
      <SkeletonElement text className="skeleton-widget__line skeleton-widget__line--1" />
      <SkeletonElement text className="skeleton-widget__line skeleton-widget__line--2" />
      <SkeletonElement text className="skeleton-widget__line skeleton-widget__line--3" />
      <SkeletonElement text className="skeleton-widget__line skeleton-widget__line--4" />
      <SkeletonElement text className="skeleton-widget__line--5" />
    </div>
  );
}
